<div class="experiences-container">
  <div class="experiences-title">
    <h2>Experience</h2>
    <h3>Where I have worked</h3>
  </div>
  <div class="experiences-list">
    <div class="row">
      <div class="experiences-element col-12 col-md-6 col-lg-6 col-xl-6 py-3"
      *ngFor="let experience of experiences">
        <app-experience-card [technologies]="technologies" [experience]="experience"></app-experience-card>
      </div>
    </div>
  </div>

</div>
